import { window } from "@swa-ui/browser";

export const getInflight = () => window.swa?.inflight ?? false;
